import ComparisonTableSection from '../ComparisonTableSection';
import ComparisonTableSectionProvider from '../ComparisonTableSectionProvider';
import SD2Table from './SD2Table';
import { SDProps } from './sd.interface';
import { useTableStore } from '../../../store/useTableStore';

const SD2 = ({ triggerCollapse, setTablesCollapsed, tablesCollapsed, collapseOnClick }: SDProps) => {
    const [data] = useTableStore((state) => [state.data]);

    return data && data.sd2 ? (
        <ComparisonTableSectionProvider>
            <ComparisonTableSection
                triggerCollapse={triggerCollapse}
                setTablesCollapsed={setTablesCollapsed}
                tablesCollapsed={tablesCollapsed}
                collapseOnClick={collapseOnClick}
                title={'2. Structuring features'}
            >
                <SD2Table />
            </ComparisonTableSection>
        </ComparisonTableSectionProvider>
    ) : null;
};

export default SD2;
